const ACTIVE_PIPELINE_ID_KEY = 'pipeline_active_pipeline_id';
const ACTIVE_PIPELINE_NAME_KEY = 'pipeline_active_pipeline_name';
const ACTIVE_PIPELINE_OWNER_EMAIL_KEY = 'pipeline_active_pipeline_owner_email';
const ACTIVE_PIPELINE_OWNER_USER_ID_KEY = 'pipeline_active_pipeline_owner_user_id';

export const getActivePipelineContext = () => {
  if (typeof localStorage === 'undefined') {
    return { id: null, name: null, ownerEmail: null, ownerUserId: null };
  }
  return {
    id: localStorage.getItem(ACTIVE_PIPELINE_ID_KEY),
    name: localStorage.getItem(ACTIVE_PIPELINE_NAME_KEY),
    ownerEmail: localStorage.getItem(ACTIVE_PIPELINE_OWNER_EMAIL_KEY),
    ownerUserId: localStorage.getItem(ACTIVE_PIPELINE_OWNER_USER_ID_KEY),
  };
};

export const setActivePipelineContext = (pipeline = {}) => {
  if (typeof localStorage === 'undefined') return;
  const id = pipeline.id || pipeline.pipeline_id || pipeline._id || '';
  const name = pipeline.pipeline_name || pipeline.name || '';
  const ownerEmail = pipeline.owner_email || pipeline.ownerEmail || '';
  const ownerUserId = pipeline.owner_user_id || pipeline.ownerUserId || '';

  if (id) localStorage.setItem(ACTIVE_PIPELINE_ID_KEY, String(id));
  else localStorage.removeItem(ACTIVE_PIPELINE_ID_KEY);

  if (name) localStorage.setItem(ACTIVE_PIPELINE_NAME_KEY, String(name));
  else localStorage.removeItem(ACTIVE_PIPELINE_NAME_KEY);

  if (ownerEmail) localStorage.setItem(ACTIVE_PIPELINE_OWNER_EMAIL_KEY, String(ownerEmail));
  else localStorage.removeItem(ACTIVE_PIPELINE_OWNER_EMAIL_KEY);

  if (ownerUserId) localStorage.setItem(ACTIVE_PIPELINE_OWNER_USER_ID_KEY, String(ownerUserId));
  else localStorage.removeItem(ACTIVE_PIPELINE_OWNER_USER_ID_KEY);
};

export const clearActivePipelineContext = () => {
  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem(ACTIVE_PIPELINE_ID_KEY);
  localStorage.removeItem(ACTIVE_PIPELINE_NAME_KEY);
  localStorage.removeItem(ACTIVE_PIPELINE_OWNER_EMAIL_KEY);
  localStorage.removeItem(ACTIVE_PIPELINE_OWNER_USER_ID_KEY);
};

export const activePipelineMatches = (pipelineName) => {
  const active = getActivePipelineContext();
  return !!active.id && !!active.name && String(active.name) === String(pipelineName || '');
};
